<template>
  <div class="container_self">
    <el-row class="table_parent">
      <h3>ReportId 管理</h3>
      <el-row>
        <el-col :span="12">
          <span style="display: inline-block; margin-right: 25px"
            >reportId：{{ reportId }}</span
          >
          <span>所属客户：{{ customerName }}</span>
        </el-col>
      </el-row>
      <el-row class="top_row">
        <span class="label">报告子ID</span>
        <el-select size="mini" v-model="subId" @change="subIdChange">
          <el-option
            v-for="(item, index) in subIdList"
            :key="index"
            :label="item.subReportId"
            :value="item.subReportId"
          ></el-option>
        </el-select>
        <el-button style="margin-left: 20px;" type="success" size="mini" @click="addSubId">创建报告子ID</el-button>
        <el-button type="danger" size="mini" @click="deleteSubId">删除报告子ID</el-button>
        <el-button type="warning" size="mini" @click="addDomain">为此ID添加域名</el-button>
        <el-button type="primary" size="mini" @click="addAppReport">添加APP</el-button>
      </el-row>

      <el-row  v-loading="loading">
        <el-table
        :data="tableData"
        :span-method="objectSpanMethod"
        border
        style="width: 100%; margin-top: 20px"

        >
        <el-table-column
          prop="subReportId"
          label="报告子ID"
          align="center"
        ></el-table-column>
        <el-table-column prop="resource"  align="center" label="域名/APP"></el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type=='domain'">域名</span>
            <span v-if="scope.row.type=='app'">APP</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.type=='domain'">
              <el-button size="mini" type="danger" @click="deleteDomain(scope.row)"
                >删除域名</el-button
              >
              <el-button size="mini" type="success" @click="addDomain(scope.row)"
                >添加域名</el-button
              >
            </div>
            <div v-if="scope.row.type=='app'">
              <el-button size="mini" type="danger" @click="deleteApp(scope.row)">删除域名</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </el-row>
    </el-row>

    <el-dialog :title="'添加域名:'+subId" :visible.sync="dialogFormVisible">
      <el-form :model="form" label-width="120px" size="mini">
        <el-form-item label="域名">
          <el-select
              v-model="form.domain"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="loadingDm">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.dm"
                :value="item.dm">
              </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="addOk" size="mini">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :title="'添加App:'+subId" :visible.sync="dialogFormVisibleApp">
      <el-form :model="form" label-width="120px" size="mini">
        <el-form-item label="包名">
          <el-select
              v-model="appForm.packageName"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethodApp"
              :loading="loadingDm">
              <el-option
                v-for="(item,index) in appList"
                :key="index"
                :label="item.appName"
                :value="item.packageName">
              </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="addAppOk" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      reportId: sessionStorage.getItem("reportId"),
      gamCustomerId:sessionStorage.getItem('gamCustomerId'),
      customerName: "",
      subIdList: [],
      subId: "",
      tableData: [],
      form: {
        domain: "",
        subReportId: "",
      },
      dialogFormVisible: false,
      loading: false,
      customerId:0,
      options:[],
      loadingDm:false,
      appList:[],
      dialogFormVisibleApp:false,
      appForm:{
        packageName:"",
        subReportId:""
      }
    };
  },
  methods: {
    addAppReport(){
      this.getAppList({currentPage:1,pageSize:10,customerId:this.gamCustomerId});
      this.dialogFormVisibleApp=true;
    },
    async getAppList(params){
      await axiosGet("/api/app_web/list",params).then(res=>{
        if(res.code==0){
          this.appList=res.data.records;
        }
      })
    },
    deleteApp(row){
      this.$confirm(`确定删除此报告id下的App: ${row.resource} 吗`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'danger'
      }).then(()=>{
        axiosPost('/api/gam/account/delete_sub_report_app',{packageName:row.resource,subReportId:row.subReportId},"JSON").then(res=>{
        if(res.code==0){
          this.$message({ message: "APP已成功删除", type: "success" });
          this.getSubDomains({ reportId: this.reportId, subReportId: this.subId,customerId:this.gamCustomerId });
        }
      })
      }).catch(err=>{})

    },
    async getSubList() {
      await axiosGet("/api/gam/account/sub_report_ids", { reportId: this.reportId,customerId:this.gamCustomerId }).then(
        (res) => {
          if (res.code == 0) {
            if (res.data.records.length) {
              this.subId = res.data.records[0].subReportId;
              this.customerId=res.data.records[0].customerId;
              this.customerName = res.data.records[0].customerName;
              this.subIdList = res.data.records;
              this.appForm.subReportId=res.data.records[0].subReportId;
            }
          }
        }
      );
    },
    async getSubDomains(params) {
      this.loading = true;
      await axiosGet("/api/gam/account/sub_report_domains", params).then((res) => {
        if (res.code == 0) {
          if (res.data.records) {
            this.tableData = res.data.records;
          }
        }
      });
      this.loading = false;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex != 0) {
        return false;
      } else {
        const currentRowId = this.tableData[rowIndex].subReportId;
        if (this.tableData.length == 1) {
          return false;
        }
        let rowspan = 0;
        //计算 rowspan
        for (let i = rowIndex; i < this.tableData.length; i++) {
          if (this.tableData[i].subReportId === currentRowId) {
            if (rowIndex == 0) {
              rowspan++;
            }
          } else {
            return { rowspan: 1, colspan: 1 };
          }
        }
        // 如果有重复，则合并
        if (rowspan > 1) {
          return { rowspan: rowspan, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },
   async remoteMethod(query) {
        if (query !== '') {
          this.loadingDm = true;
          await axiosGet('/api/domains/list',{customerId:this.gamCustomerId,keyword:query}).then(res=>{
            if(res.code==0){
              if(res.data.records){
                this.options=res.data.records;
              }else{
                this.options = [];
              }
            }
          })
          this.loadingDm=false;
        } else {
          this.options = [];
        }
      },
    async remoteMethodApp(query) {
      if (query !== '') {
        this.getAppList({currentPage:1,pageSize:10,customerId:this.gamCustomerId,keyword:query});
      }
    },
    deleteDomain(row) {
      this.$confirm(`确定删除此报告id下的域名: ${row.domain} 吗`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'danger'
        }).then(() => {
          axiosPost(
            "/api/gam/account/delete_sub_report_domain",
            { domain: row.domain, subReportId: row.subReportId },
            "JSON"
          ).then((res) => {
            if (res.code == 0) {
              this.getSubDomains({ reportId: this.reportId, subReportId: this.subId,customerId:this.gamCustomerId });
              this.$message({ message: "此域名已成功删除", type: "success" });
            }
          });
        }).catch(() => {});
    },
    addDomain(row) {
      this.form.subReportId = row.subReportId||this.subId;
      this.dialogFormVisible = true;
    },
    addOk() {
      if (!this.form.domain) {
        this.$message({ message: "请先输入要添加的域名", type: "error" });
        return false;
      } else {
        axiosPost("/api/gam/account/add_domain_sub_report", this.form, "JSON").then(
          (res) => {
            if (res.code == 0) {
              this.getSubDomains({ reportId: this.reportId, subReportId: this.subId,customerId:this.gamCustomerId });
              this.$message({ message: "域名已成功加入到此报告子ID", type: "success" });
              this.dialogFormVisible=false;
              this.form.domain="";
            }
          }
        );
      }
    },
    addAppOk(){
      if (!this.appForm.packageName) {
        this.$message({ message: "请先输入app名称", type: "error" });
        return false;
      }else{
        axiosPost("/api/gam/account/add_app_sub_report", this.appForm, "JSON").then(res=>{
          if(res.code==0){
            this.dialogFormVisibleApp=false;
            this.getSubDomains({ reportId: this.reportId, subReportId: this.subId,customerId:this.gamCustomerId });
            this.form.packageName="";
            this.$message({ message: "APP已成功加入到此报告子ID", type: "success" });
          }
        })
      }
    },
    subIdChange(val) {
      this.getSubDomains({ reportId: this.reportId, subReportId: val,customerId:this.gamCustomerId });
      this.subIdList.forEach(element => {
        if(val===element.subReportId){
          this.customerName=element.customerName;
          this.customerId=element.customerId;
        }
      });
    },
    async deleteSubId() {
      if (!this.subId) {
        this.$message({ message: "请先选择要删除的报告子ID", type: "error" });
        return false;
      } else if (this.tableData.length) {
        this.$message({ message: "请先删除此id下的所有域名", type: "error" });
        return false;
      } else {
        this.$confirm(`确定删除此报告的子id: ${this.subId} 吗`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'danger'
        }).then(() => {
          axiosPost(
              "/api/gam/account/delete_sub_report_id",
              { subReportId: this.subId },
              "JSON"
            ).then((res) => {
              if (res.code == 0) {
                this.reloadData();
                this.$message({ message: "此报告子ID已成功删除", type: "success" });
              }
            });
        }).catch(() => {});
      }
    },
   async addSubId() {
     await axiosPost(
        "/api/gam/account/create_sub_report_id",
        { customerId: this.gamCustomerId,googleReportId:this.reportId },
        "JSON"
      ).then((res) => {
        if (res.code == 0) {
          this.reloadData();
          this.$message({ message: "报告子ID创建成功", type: "success" });
        }
      });
    },
    async reloadData(){
      await this.getSubList();
      await this.getSubDomains({ reportId: this.reportId, subReportId: this.subId,customerId:this.gamCustomerId });
    }
  },
  async mounted() {
   this.reloadData();
  },
};
</script>

<style>
.top_row {
  margin: 20px 0 15px 0;
}
.top_row .label {
  font-size: 14px;
  display: inline-block;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/GamManager/reportIdManager.vue